import './App.css';
import 'flowbite';
import Homepage from './Pages/Homepage';
import Footer from './components/Footer';

function App() {
    return (
        <div className="App bg-[#111827]">
            <Homepage />
            <Footer />
        </div>
    );
}

export default App;
